module.exports = __webpack_public_path__ + "img/0603-k.c873348e.svg";